export default {"src":"/_next/static/media/logo.fc412bff.gif","height":1072,"width":492,"blurWidth":0,"blurHeight":0};